import { Injectable, signal } from '@angular/core';

import { BreadcrumbItem } from '@treetop/shared/model';

@Injectable()
export class BreadcrumbService {
  public visibleItems = signal<BreadcrumbItem[]>([]);
  public collapsedItems = signal<BreadcrumbItem[]>([]);
  private breadcrumb: BreadcrumbItem[] = [];

  public setBreadcrumb(breadcrumb: BreadcrumbItem[]) {
    this.breadcrumb = breadcrumb;
    this.updateBreadCrumbs();
  }

  public getTotalTextWidth(targetElement: HTMLElement): number {
    let totalTextWidth = 0;
    targetElement.childNodes.forEach((childNode) => {
      if (childNode.nodeType === Node.ELEMENT_NODE) {
        totalTextWidth += (childNode as HTMLElement).offsetWidth;
      } else if (childNode.nodeType === Node.TEXT_NODE) {
        totalTextWidth += this.getTextNodeWidth(childNode);
      }
    });

    return totalTextWidth;
  }

  public calculateCollapse(textWidth: number, parentElement: HTMLElement) {
    const parentWidth = parentElement?.offsetWidth - 40 || 0;

    if (textWidth > parentWidth) {
      this.collapseItems();
    } else {
      this.expandItems();
    }
  }

  public updateBreadCrumbs() {
    this.collapsedItems.set([]);
    this.visibleItems.set(this.breadcrumb);
  }

  private collapseItems() {
    this.collapsedItems.set(this.breadcrumb.slice(1, -1));
    this.visibleItems.set(this.breadcrumb.filter((item) => !this.collapsedItems().includes(item)));
  }

  private expandItems() {
    this.collapsedItems.set([]);
    this.visibleItems.set(this.breadcrumb);
  }

  private getTextNodeWidth(textNode: Node | null): number {
    if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return 0;

    const range = document.createRange();
    range.selectNodeContents(textNode);

    return range.getBoundingClientRect().width;
  }
}
